import { render, staticRenderFns } from "./copyHsab.vue?vue&type=template&id=3a1b6f5d"
import script from "./copyHsab.vue?vue&type=script&lang=js"
export * from "./copyHsab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports